import { useTranslation } from 'react-i18next';
import MainTitle from '../common/MainTitle';
import ContactInfo from '../common/ContactInfo';

import ImageLink from '../../js/utils/ImageLink';

export default function ConnectWithUs({ image }) {
  const { t } = useTranslation(['HomePage', 'ContactPage']);

  return (
    <section className="connect-with-us">
      <div className="connect-with-us__wrapper">
        <MainTitle type="dark" className="text--2xl hidden--lg">
          <span>{t('contactUs')}</span>
          {/* <span className="decorated-line decorated-line--dark decorated-line--left">
            {t('hearFromYou')}
          </span> */}
        </MainTitle>

        <div className="connect-with-us__content">
          <MainTitle type="dark" className="text--2xl hidden--md">
            <span>{t('contactUs')}</span>
            {/* <span className="decorated-line decorated-line--dark decorated-line--left">
              {t('hearFromYou')}
            </span> */}
          </MainTitle>

          <ContactInfo theme="light" layout="narrow" />
        </div>
        {image && (
          <div className="connect-with-us__media">
            <picture>
              <source srcSet={ImageLink(image?.url)} type="image/webp" />
              <img src={ImageLink(image?.url)} alt={image?.alt} />
            </picture>
          </div>
        )}
      </div>
    </section>
  );
}
